import React, { createContext, useEffect } from 'react';
import { useDisclosure } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { SidebarContextData } from './types';

export const SidebarContext = createContext({} as SidebarContextData);

export const SidebarProvider: React.FC = ({ children }) => {
  const disclosure = useDisclosure();
  const history = useHistory();

  useEffect(() => {
    disclosure.onClose();
  }, [history]);

  return (
    <SidebarContext.Provider value={disclosure}>
      {children}
    </SidebarContext.Provider>
  );
};
